import React from 'react';
import PropTypes from 'prop-types';
import { bem } from 'helpers/class-name';
import { intlMessageShape } from 'constants/propTypes';
import Message from 'components/Message';
import Button from 'components/Button';
import messages from '../ReservationFeedbackModalV2.messages';

import './ReasonCard.scss';

export const REASONS = {
  DISRUPTIVE_USER: 'disruptiveUser',
  TRIAL_PROGRAM_ABUSE: 'trialProgramAbuse',
};

const { element } = bem('reason');

const ReasonCard = ({ reason, title, description, isAlreadyReported, onSelect }) => {
  return (
    <div className={element('reason-card')}>
      <div className={element('reason-card-content')}>
        <div className={element('reason-card-text')}>
          <h3 className={element('reason-title')}>
            <Message message={title} />
          </h3>
          <p className={element('reason-description')}>
            <Message message={description} />
          </p>
        </div>
        <Button
          className={element('reason-select-button', { 'already-reported': isAlreadyReported })}
          disabled={isAlreadyReported}
          styled="primary-outline"
          type={Button.TYPES.BUTTON}
          onClick={() => onSelect(reason)}>
          <Message message={isAlreadyReported ? messages.userAlreadyReported : messages.select} />
        </Button>
      </div>
    </div>
  );
};

ReasonCard.propTypes = {
  reason: PropTypes.oneOf(Object.values(REASONS)).isRequired,
  title: PropTypes.shape(intlMessageShape).isRequired,
  description: PropTypes.shape(intlMessageShape).isRequired,
  isAlreadyReported: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

export default ReasonCard;
